import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const pageTitle = "PhotoDaily";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: { title: pageTitle },
  },
  {
    path: "/photo/:slug",
    name: "Photo",
    component: () => import("../components/PhotoView.vue"),
    meta: { title: pageTitle },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;
  next();
});

export default router
